import React from 'react';
import { withIcon } from '../../../../components/withIcon/withIcon.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgSpotifyFilled = (_a) => {
  var _b = _a, { size, title = "SpotifyFilled" } = _b, props = __objRest(_b, ["size", "title"]);
  return /* @__PURE__ */ React.createElement("svg", __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    "data-icon-name": title,
    "aria-label": title,
    role: "presentation"
  }, props), /* @__PURE__ */ React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /* @__PURE__ */ React.createElement("path", {
    fillRule: "nonzero",
    d: "M17.323 10.978c-2.9-1.722-7.686-1.88-10.455-1.04a.842.842 0 11-.489-1.611c3.18-.965 8.464-.779 11.804 1.204a.842.842 0 01-.86 1.447zm-.094 2.552a.702.702 0 01-.965.231c-2.42-1.487-6.107-1.917-8.969-1.049a.703.703 0 01-.407-1.342c3.268-.992 7.331-.512 10.11 1.195.33.204.434.636.23.965zm-1.102 2.45a.56.56 0 01-.771.187c-2.114-1.291-4.774-1.583-7.906-.868a.56.56 0 11-.25-1.093c3.428-.784 6.369-.446 8.741 1.003a.56.56 0 01.186.772zM12 3a9 9 0 100 18 9 9 0 100-18z"
  })));
};
var SpotifyFilled = withIcon(SvgSpotifyFilled);

export { SpotifyFilled as default };
//# sourceMappingURL=SpotifyFilled.es.js.map
